<template>

  <div id="order">
    <div class="order_content">

      <div class="order_info">

        <div class="order_top">
          <img src="../assets/images/timer.png" />
          <div class="order_info_right">
            <h2>{{roomid}}房下单成功！</h2>
            <p>请等待服务员马上配送上门!</p>
          </div>
        </div>


        <h3>已点商品数量{{list.total_num}},合计 : <span class="price">{{list.total_price}}元</span> </h3>

      </div>

      <!--订单列表-->

      <div class="order_list">

        <h3>商品详情:</h3>
        <ul class="list">
          <li v-for="item in list.items">
            <div class="title" v-if="item.cool">
              {{item.title}}/{{item.cool}}
              <!--已下单-->
            </div>

            <div class="title" v-if="!item.cool">
              {{item.title}}
              <!--已下单-->
            </div>

            <div class="num">

              {{item.num}}份
            </div>


            <div class="price">

              {{item.price}}元
            </div>

          </li>


        </ul>

      </div>


    </div>


    <v-navfooter></v-navfooter>


    <div id="footer_book" class="footer_book" style="left:auto;right:5px;">
      <router-link to="/home">
        <img src="../assets/images/menu.png" />
        <p>菜单</p>
      </router-link>
    </div>
  </div>
</template>


<script>
  //引入NavFooter组件
  import NavFooter from './public/NavFooter.vue';

  //引入配置文件

  import Config from '../model/config.js';
  import storage from '../model/storage.js';

  export default {

    data() {
      return {
        api: Config.api,
        list: [], //此处声明模板中需要的变量，在create或mounted中赋值
        roomid: '',
      }
    },
    components: {

      'v-navfooter': NavFooter
    },
    methods: {

      getOrder() {

        var uid = storage.get('roomid');
        this.roomid = uid; //szy add显示房号
        var api = this.api + 'api/getOrder?uid=' + uid;

        this.$http.get(api).then((response) => {
          console.log(response);
           //如果获取不到，可能是服务端EXE已经改变状态了。没关系实质已经下单成功了
          this.list = response.body.result[0];
          //szy add看到完整订单后，立即清空缓存的房号。复杂问题简单化
          //storage.remove('roomid');//szy add没必要清空，因为中转程序里面将主单改为取消了。每次转到云MSSQL后，都是重新产生新主单

        }, (error) => {
          console.log(error);
        })

      }
    },
    mounted() {

      this.getOrder();
    }
  }
</script>

<style lang="scss">
  .order_content {
    padding: 1rem;


    .order_info {

      background: #fff;

      border-radius: .5rem;

      .order_top {

        display: flex;

        img {
          width: 5.6rem;
          height: 5.6rem;
        }

        .order_info_right {
          flex: 1;
          padding-top: .5rem;

        }

      }

      h3 {

        line-height: 2;
        padding: .5rem;

        .price {
          font-size: 2rem;

          color: red;
        }
      }
    }


    //  订单列表


    .order_list {

      background: #FFFFFF;
      border-radius: .5rem;
      margin-top: 1rem;

      padding: .5rem;

      h3 {

        line-height: 2;
      }


      .list {


        li {

          display: flex;

          font-size: 2rem;

          line-height: 2;
          padding: .5rem 0rem;

          .title {

            flex: 2;
          }

          .num {
            flex: 1;
            text-align: center;
          }

          .price {
            flex: 1;

            text-align: center;
          }
        }
      }

    }

    /*支付页面*/
    .order_pay {


      background: #fff;

      border-radius: .5rem;

      h3 {

        padding: 2rem 0rem .5rem 0rem;

        font-size: 2rem;
        text-align: center;

      }

      .order_pay_detail {
        display: flex;

        line-height: 2;

        border-bottom: 1px solid #eee;

        padding: .5rem;

        .d_num,
        .p_num,
        .order_time {

          flex: 1;
        }
      }

      .order_pay_info {

        line-height: 2;

        display: flex;

        margin: 1rem 0rem;
        padding: .5rem .5rem 1rem .5rem;


        .price_list {
          flex: 1;

          .price {

            font-size: 2rem;

            color: red;
          }
        }

        .pay_button {

          width: 10rem;
          border-radius: .5rem;
          background: red;
          color: #fff;
          text-align: center;
          height: 2.6rem;
          line-height: 2.6rem;
          position: relative;

          top: .5rem
        }
      }
    }



  }
</style>



// WEBPACK FOOTER //
// src/components/Order.vue